import { BASE_URL } from './Config'; 

export class LoginService {
  
  async performLogin(credentials) {
 
    try {
      const response = await fetch(`${BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });
  
     
  
      if (!response.ok) {
        throw new Error('Authentication failed');
      }
  
      const userData = await response.json(); // Parse JSON response
  
      // Extract token from userData
      const token = userData.token;
  
      // Log token received, handling case when token is null or undefined
      if (token !== undefined && token !== null) {
      
  
        // Store token in local storage or session storage
       // Store the token in localStorage
       localStorage.setItem('accessToken', userData.token);
      } else {
      
        throw new Error('Token not received');
      }
  
      return userData; // Return user data assuming backend returns user data
  
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  }
  
}
